import {
  useState,
} from 'react';
import {
  shallowEqual,
  useSelector,
  useDispatch,
} from 'react-redux';
import {
  uiActions,
} from 'web-actions';
import {
  getUiState,
} from 'web-selectors';

import {
  coreSelectors,
} from '@gymcloud/core';

import {
  Icon,
  Popup,
  Tooltip,
} from 'web-components';

import {
  Flex,
  Text,
} from 'web-styled';

import * as S from './styled';
import * as ParentS from '../../styled';

const mapState = (state: any) => ({
  items: coreSelectors.getSelectionResourceMappedList(
    'documents',
    'library',
  )(state),
  ...getUiState([
    'fileUpload',
    'uploadFileModal',
  ])(state),
});

type Props = {
  onLink: { (item: any): void },
};

const Links = ({
  onLink,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const { items } = useSelector(mapState, shallowEqual);
  const dispatch = useDispatch();

  return (
    <Popup
      isOpen={isOpen}
      trigger={(
        <Flex>
          <Tooltip body="Link Document" positions={['top']} >
            <ParentS.Control>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width={14}
                height={14}
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="m16 6-8.414 8.586a2 2 0 0 0 2.829 2.829l8.414-8.586a4 4 0 1 0-5.657-5.657l-8.379 8.551a6 6 0 1 0 8.485 8.485l8.379-8.551" />
              </svg>
            </ParentS.Control>
          </Tooltip>
        </Flex>
      )
      }
      setPopupVisible={(e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsOpen(!isOpen);
      }}
      onClickOutside={() => setIsOpen(false)}
    >
      <S.Dropdown>
        <Flex
          column
          padding="10px 20px 5px 20px"
          spacing={5}
        >
          <Text
            size="12px"
            color="#999999"
          >
            SELECT DOCUMENT
          </Text>
          < Flex
            align="center"
            spacing={5}
            clickable
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();

              dispatch(
                uiActions.setUiState({
                  fileUpload: {},
                  uploadFileModal: {
                    isOpen: true,
                  },
                }),
              );
              setIsOpen(false);
            }}
          >
            <S.PlusCircle />
            < Text
              color="primary"
            >
              ADD DOCUMENT
            </Text>
          </Flex>
        </Flex>
        {
          items.map(item => (
            <S.Item
              key={item.id}
              onMouseDown={() => {
                onLink(item);
                setIsOpen(false);
              }}
            >
              {item.name}
            </S.Item>
          ))}
      </S.Dropdown>
    </Popup>
  );
};

export default Links;
